var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAPITypes } from "../factory";
import { TypeRegistry } from "@polkadot/types";
import { JsonRpcClient } from "./client";
import { newCurrencyId } from "../utils";
/**
 * @category Clients
 */
export class FaucetClient extends JsonRpcClient {
    constructor(api, url) {
        super(url);
        this.api = api;
        this.registry = new TypeRegistry();
        this.registry.register(getAPITypes());
        this.constr = {
            FundAccountJsonRpcRequest: this.registry.createClass("FundAccountJsonRpcRequest"),
        };
    }
    fundAccount(account, currency) {
        return __awaiter(this, void 0, void 0, function* () {
            const currencyId = newCurrencyId(this.api, currency);
            const request = new this.constr["FundAccountJsonRpcRequest"](this.registry, {
                account_id: account,
                currency_id: currencyId,
            });
            yield this.post("fund_account", [request.toHex()]);
        });
    }
}
//# sourceMappingURL=faucet.js.map